import { MainContext } from './../../models/main-context.model';
import { createFeatureSelector, createSelector } from '@ngrx/store';


export const selectContextState = createFeatureSelector<MainContext>('context');
export const selectContextEntity = createSelector(selectContextState, (state) => state.entity);
export const selectContextLoading = createSelector(selectContextState, (state) => state.loading);
export const selectContextLoaded = createSelector(selectContextState, (state) => state.loaded);
